module.exports = __webpack_public_path__ + "media/images/icons/ic-right-33bbe33eb6a307b24b636f23786c2f3b.svg";